import styled, { css } from 'styled-components'

import { Button, ButtonBack, ButtonIcon, ButtonPrimary } from '../Button/styles'

export const Wrapper = styled.div`
  background: #ffffff;
  padding: 30px 30px 30px 30px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  -webkit-box-shadow: 0px 0px 4px rgb(0 0 0 / 10%);
  box-shadow: 0px 0px 4px rgb(0 0 0 / 10%);
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
`

export const SubTitle = styled.h3`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
  color: #4a4a4a;
`

export const Description = styled.p`
  font-size: 15px;
  line-height: 20px;
`
export const FormGroup = styled.div`
  /* margin-bottom: 20px; */
  position: relative;
  font-size: 14px;
  width: 70%;
  margin-bottom: -12px;
`

export const Box = styled.div`
  margin-top: 10px;
  display: flex;
`

export const Validar = styled.div`
  height: 41px;
  margin-left: 10px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  background: transparent;
  border-radius: 4px;
  color: #7b7b7b;
  border: 2px solid #7b7b7b;
  cursor: initial;
`
export const Limpar = styled.button`
  height: 41px;
  border-radius: 4px;
  border: 2px solid transparent;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 16px;
  padding: 15px 30px;
  text-align: center;
  -webkit-transition: all 400ms;
  -moz-transition: all 400ms;
  transition: all 400ms;
  background: #d22630;
  color: white;
  border: 2px solid #d22630;
  cursor: pointer;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const Resgatar = styled.button`
  height: 41px;
  border-radius: 4px;
  border: 2px solid transparent;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 16px;
  padding: 15px 30px;
  text-align: center;
  -webkit-transition: all 400ms;
  -moz-transition: all 400ms;
  transition: all 400ms;
  background: #5cc187;
  color: white;
  border: 2px solid #5cc187;
  cursor: pointer;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`
